import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MsgBoxComponent } from './msg-box.component';
import { ConfirmBoxComponent } from './confirm-box.component';
import { AlertBoxComponent } from './alert-box.component';

var CLOSE_BTN_TEXT = 'Close';

@Injectable({
  providedIn: 'root',
})
export class MsgBoxService {

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog) {

  }

  public showSuccessMsg(message: string) {
    this.snackBar.openFromComponent(MsgBoxComponent, { data: { message: message, button: CLOSE_BTN_TEXT, msgType: 'Success' } });
  }

  public showErrorMsg(message: string) {
    this.snackBar.openFromComponent(MsgBoxComponent, { data: { message: message, button: CLOSE_BTN_TEXT, msgType: 'Error' } });
  }

  public showWarnMsg(message: string) {
    this.snackBar.openFromComponent(MsgBoxComponent, { data: { message: message, button: CLOSE_BTN_TEXT, msgType: 'Warn' } });
  }

  public showInfoMsg(message: string) {
    this.snackBar.openFromComponent(MsgBoxComponent, { data: { message: message, button: CLOSE_BTN_TEXT, msgType: 'Info' } });
  }

  public showAlert(msgObj: any) {
    this.snackBar.openFromComponent(AlertBoxComponent, { data: { data: msgObj, button: CLOSE_BTN_TEXT, msgType: 'Info', isAlert: true } });
  }

  public showConfirmMsgBox(message: string, title?: string, yesTitle?: string, noTitle?: string): Promise<boolean> {
    return this.dialog.open(ConfirmBoxComponent,
      ConfirmBoxComponent.createDialogConfig(message, title, yesTitle, noTitle)).afterClosed().toPromise();
  }
}
